export default __webpack_public_path__ + "static/media/1.547a5118.png";